export var sortByProductName = function (products) {
    return products.sort(function (x, y) {
        if (x.productName > y.productName) {
            return 1;
        }
        if (x.productName < y.productName) {
            return -1;
        }
        return 0;
    });
};
